import request from "@/utils/request.js"

// 获取下载中心分类及列表
export function get_download_list(data) {
	return request({
		method: 'GET',
		url: '/aohua.download/get_list',
		params: data
	})
}

// 下载前权限校验：登录 + 审核通过 + 状态开启
// download 端点本身公开(供邮件/外链永久链接)，故权限由本接口校验
export function check_download(data) {
	return request({
		method: 'GET',
		url: '/aohua.download/check',
		params: data
	})
}
